export default __webpack_public_path__ + "static/kemp-4aad835a14902066058c111725981d35.jpg";